import React from 'react';
import './BookMenu.scss';

const TOTAL_PAGES = 15;
const pages = Array.from(
  { length: TOTAL_PAGES },
  (_, i) => `/menu-pages/page-${String(i + 1).padStart(2, '0')}.jpg`
);

const BookMenu = () => (
  <div className="book-menu">
    <header className="book-menu__header">
      <img src="/haveli-logo.png" alt="Haveli" className="book-menu__logo" />
      <div>
        <h1>Haveli Restaurant</h1>
        <p>The Royal Experience</p>
      </div>
    </header>

    <main className="book-menu__pages">
      {pages.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={`Menu page ${i + 1}`}
          width={1200}
          height={1696}
          loading={i < 2 ? 'eager' : 'lazy'}
          className="book-menu__page"
        />
      ))}
    </main>

    <button
      className="book-menu__top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
    >
      ↑
    </button>
  </div>
);

export default BookMenu;
